var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general-group",on:{"click":function($event){$event.stopPropagation();}}},[_c('generalGroup',{attrs:{"color":"#1597a5","width":"18px","height":"18px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }